module.exports = __webpack_public_path__ + "img/2.3c3334ee.png";